import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }

import { Alert } from '@/components/ui/alert';
    import { computed, ref } from 'vue';
    import { Input } from '@/components/ui/input';
    import { InputRow, Select, Combobox } from '@/components/ui/form';
    import EmployeeOptionalInput from '@/components/employees/EmployeeOptionalInput.vue';
    import FileView from '@/components/FileView.vue';
    import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';
    import type { Company, Employee, FileItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeOptionalForm',
  props: {
    form: {},
    company: {},
    danmarksStatistikData: {},
    employee: {}
  },
  setup(__props: any) {

    const props = __props;

    const dstValuesOptions = computed(() => {
        const types = props.danmarksStatistikData?.dstValues?.employmentTypes ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const hiredTermsOptions = computed(() => {
        const types = props.danmarksStatistikData?.dstValues?.hiredTerms ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const jobStatusesOptions = computed(() => {
        const types = props.danmarksStatistikData?.dstValues?.jobStatuses ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const salaryFormsOptions = computed(() => {
        const types = props.danmarksStatistikData?.dstValues?.salaryForms ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const discoCodesOptions = computed(() => {
        const types = props.danmarksStatistikData?.discoCodes ?? [];

        return Object.entries(types).map(([key, label]) => ({
            value: key,
            label: label as string,
        }));
    });

    const carFile = ref<FileItem | null>({
        name: props.employee?.employment?.free_car_filename,
        url: route('v2.salary.employees.download-free-car-contract', props.employee?.id),
    } as FileItem);

    const deleteCarFile = () => {
        props.form.employment.remove_free_car_file = true;
        carFile.value = null;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.company.employees_optional.has_free_car)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 0,
          form: _ctx.form,
          label: "employee.optional.has_free_car",
          value: "employment.has_free_car"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "free_car_monthly",
              label: "employee.employment.free_car_monthly"
            }, {
              default: _withCtx(() => [
                _createVNode(ThousandSeparatorInput, {
                  modelValue: _ctx.form.employment.free_car_monthly,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.employment.free_car_monthly) = $event)),
                  placeholder: _ctx.$t('employee.employment.free_car_monthly'),
                  "with-decimals": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "free_car_file",
              label: "employee.employment.free_car_file"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "free_car_file",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.employment.free_car_file = $event.target.files[0])),
                  placeholder: _ctx.$t('employee.employment.free_car_file'),
                  type: "file",
                  accept: "image/png,image/gif,image/jpeg,application/pdf,.xlsx,.xls,.csv"
                }, null, 8, ["placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            (carFile.value?.name)
              ? (_openBlock(), _createBlock(FileView, {
                  key: 0,
                  file: carFile.value,
                  previewable: false,
                  onDelete: deleteCarFile
                }, null, 8, ["file"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "free_car_file_description",
              label: "employee.employment.free_car_file_description"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  id: "free_car_file_description",
                  modelValue: _ctx.form.employment.free_car_file_description,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.employment.free_car_file_description) = $event)),
                  placeholder: _ctx.$t('employee.employment.free_car_file_description')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(Alert), { variant: "warning" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('employee.employment.free_car_file_description_warning')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.kilometer)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 1,
          form: _ctx.form,
          label: "employee.employment.kilometer",
          value: "employment.kilometer"
        }, null, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.has_free_phone)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 2,
          form: _ctx.form,
          label: "employee.employment.has_free_phone",
          value: "employment.has_free_phone"
        }, null, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.has_lunch_arrangement)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 3,
          form: _ctx.form,
          label: "employee.employment.has_lunch_arrangement",
          value: "employment.has_lunch_arrangement"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "lunch_arrangement_monthly",
              label: "employee.employment.lunch_arrangement_monthly",
              "error-key": "employment.lunch_arrangement_monthly"
            }, {
              default: _withCtx(() => [
                _createVNode(ThousandSeparatorInput, {
                  modelValue: _ctx.form.employment.lunch_arrangement_monthly,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.employment.lunch_arrangement_monthly) = $event)),
                  placeholder: _ctx.$t('employee.employment.lunch_arrangement_monthly'),
                  "with-decimals": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.has_fixed_add_ons)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 4,
          form: _ctx.form,
          label: "employee.employment.has_fixed_add_ons",
          value: "employment.has_fixed_add_ons"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "fixed_add_ons_monthly",
              label: "employee.employment.fixed_add_ons_monthly",
              "error-key": "employment.fixed_add_ons_monthly"
            }, {
              default: _withCtx(() => [
                _createVNode(ThousandSeparatorInput, {
                  modelValue: _ctx.form.employment.fixed_add_ons_monthly,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.employment.fixed_add_ons_monthly) = $event)),
                  placeholder: _ctx.$t('employee.employment.fixed_add_ons_monthly'),
                  "with-decimals": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["form"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.has_pension)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 5,
          form: _ctx.form,
          label: "employee.employment.has_pension",
          value: "employment.has_pension"
        }, null, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.health_insurance)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 6,
          form: _ctx.form,
          label: "employee.employment.health_insurance",
          value: "employment.has_health_insurance"
        }, null, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.company.employees_optional.danmarks_statistik)
      ? (_openBlock(), _createBlock(EmployeeOptionalInput, {
          key: 7,
          form: _ctx.form,
          label: "employee.employment.danmarks_statistik",
          value: "employment.danmarks_statistik"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "dst_time_limited_employment",
              label: "employee.employment.dst_time_limited_employment",
              "error-key": "employment.dst_time_limited_employment"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _ctx.form.employment.dst_time_limited_employment,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.employment.dst_time_limited_employment) = $event)),
                  options: dstValuesOptions.value
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "disco_code",
              label: "employee.employment.disco_code",
              "error-key": "employment.disco_code"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Combobox), {
                  modelValue: _ctx.form.employment.disco_code,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.employment.disco_code) = $event)),
                  options: discoCodesOptions.value,
                  "show-remove-button": false,
                  position: "popper"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "dst_hired_terms",
              label: "employee.employment.dst_hired_terms",
              "error-key": "employment.dst_hired_terms"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _ctx.form.employment.dst_hired_terms,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.employment.dst_hired_terms) = $event)),
                  options: hiredTermsOptions.value
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "dst_job_status",
              label: "employee.employment.dst_job_status",
              "error-key": "employment.dst_job_status"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _ctx.form.employment.dst_job_status,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.employment.dst_job_status) = $event)),
                  options: jobStatusesOptions.value
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"]),
            _createVNode(_unref(InputRow), {
              form: _ctx.form,
              name: "dst_salary_form",
              label: "employee.employment.dst_salary_form",
              "error-key": "employment.dst_salary_form"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _ctx.form.employment.dst_salary_form,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.employment.dst_salary_form) = $event)),
                  options: salaryFormsOptions.value
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["form"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true)
  ]))
}
}

})